import React from 'react';
import { useSelector } from 'react-redux';
import Avatar from '../../../../../avatar/Avatar';
import { Skeleton, Typography } from '@mui/material';
import TextEllipsis from '../../../../../text/TextEllipsis';
import Selector from './Selector';
import AvatarSkeleton from '../../../../../avatar/AvatarSkeleton';

const StudentInfo = ({ type }) => {
  const student = useSelector((state) => state?.classMarking?.student);
  const studentLoading = useSelector((state) => state?.classMarking?.studentLoading);
  const permissions = useSelector((state) => state?.session?.permissions?.['marking-class'] || {});
  if (!student || !student?._id) return <></>;

  const { code, photo, fullName } = student;
  return (
    <>
      <div
        className={[
          'flex flex-col items-center justify-center absolute bottom-0 left-0 right-2',
          !permissions['student-selector'] ? 'top-0' : ' '
        ].join(' ')}
        style={{ zIndex: -1 }}
      >
        <Typography color='primary' variant='h6'>
          {studentLoading ? <Skeleton width={90} /> : code}
        </Typography>
        <TextEllipsis className='max-w-180px'>
          {studentLoading ? <Skeleton width={120} /> : fullName}
        </TextEllipsis>
        {/* <Typography color="primary" component={'span'} variant='inherit'  className='text-xs' >
          { studentLoading ? <Skeleton width={90}/> : student.studentId}
        </Typography> */}
        <div className='mt-2'>
          {studentLoading ? (
            <AvatarSkeleton variant='rounded' />
          ) : (
            <Avatar alt={code} src={`photos/${photo}`} variant='rounded' />
          )}
        </div>
      </div>
      {type === 'student-view' && <Selector />}
    </>
  );
};

export default StudentInfo;
